import React from "react";

import { Badge, Card, Stat, StatGrid } from "../../../Ui/index.jsx";
import { AdminTab, TabLoading, timeAgo } from "./adminShared.jsx";

const STATUS_LABEL = { up: "Up", down: "Down", not_configured: "Not configured" };

// What this integration is allowed to move, in plain words. Stated on the page rather than buried in code,
// because the question "what do we hand to them, and what do they hand us" should be answerable by looking.
function Exchange({ title, lines = [] }) {
  return (
    <div>
      <h4 className="ds-label">{title}</h4>
      <ul className="Adm-List">
        {lines.map((line) => (
          <li key={line} className={/^(nothing|never)/i.test(line) ? "ds-muted" : undefined}>{line}</li>
        ))}
      </ul>
    </div>
  );
}

export function IntegrationsHealthTab({ health }) {
  if (!health) return <TabLoading />;
  const rows = health.integrations || [];
  return (
    <AdminTab title="Integrations"
      subtitle={health.any_down ? `${health.down.join(", ")} not doing anything right now` : "All checked integrations are up"}>
      {rows.map((row) => (
        // "not_configured" reads as red too, the same weight as "down": a key someone never set and a key someone
        // accidentally cleared both mean the integration isn't doing anything right now. The text says which one it is.
        <Card key={row.name} title={row.name} actions={<Badge variant={row.status === "up" ? "success" : "danger"} dot>{STATUS_LABEL[row.status] || row.status}</Badge>}
          subtitle={`Checked ${timeAgo(row.checked_at)}${row.last_used ? ` · last used ${timeAgo(row.last_used)}` : ""}`}>
          <div className="Adm-Stack">
            <p>{row.detail}</p>
            {/* How much has actually crossed. A status dot says the pipe is open; these say what went through it. */}
            {!!row.volume?.length && (
              <StatGrid>
                {row.volume.map(([label, value]) => (
                  <Stat key={label} label={label} value={typeof value === "number" ? value.toLocaleString() : value} />
                ))}
              </StatGrid>
            )}
            {(!!row.sends?.length || !!row.receives?.length) && (
              <div className="Adm-Exch">
                <Exchange title="Intranet sends" lines={row.sends} />
                <Exchange title="Intranet receives" lines={row.receives} />
              </div>
            )}
          </div>
        </Card>
      ))}
    </AdminTab>
  );
}
